import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-homeone-banner',
    templateUrl: './homeone-banner.component.html',
    styleUrls: ['./homeone-banner.component.scss']
})
export class HomeoneBannerComponent implements OnInit {

    constructor(public router: Router) { }

    currentVideoIndex = -1;
    currentUrl = '/#home'
    orgvids = [
        'https://imgvid.blob.core.windows.net/imgvid/bg_video.mp4'
    ];
  
    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if(event instanceof NavigationEnd) {
                if(this.currentUrl !== event.url && event.url === '/#home') {
                    this.currentUrl = event.url
                    this.currentVideoIndex = -1
                    this.playNextVideo();
                }
            }
        });

        const videoElement = document.getElementById('background-video') as HTMLVideoElement;
        videoElement.addEventListener('ended', () => this.playNextVideo());
        this.playNextVideo();
    }
  
    playNextVideo(): void {
        this.currentVideoIndex = (this.currentVideoIndex + 1) % this.orgvids.length
        const nextVideo = this.orgvids[this.currentVideoIndex]
        const videoElement = document.getElementById('background-video') as HTMLVideoElement;
        videoElement.src = nextVideo;
        videoElement.load();
        videoElement.muted = true;
        videoElement.play();
    }

    mainBannerContent: Content[] = [
        {
            title: "MultiModal AI for Industrial Enterprises",
            paragraphText: 'Scalable and extensible computer vision platform for monitoring, surveillance, and custom vision applications. Configure intelligence and deploy actions on your camera in a matter of minutes.',
            defaultBtnIcon: 'flaticon-structure',
            defaultBtnText: 'How it Works',
            defaultBtnLink: 'about-us-2',
            videoBtnIcon: 'flaticon-google-play',
            videoBtnText: 'Watch Demo',
            videoBtnLink: 'https://www.youtube.com/watch?v=9sRltR2V2PA'
        }
    ]

}
class Content {
    title : string;
    paragraphText : string;
    defaultBtnIcon : string;
    defaultBtnText: string;
    defaultBtnLink : string;
    videoBtnIcon : string;
    videoBtnText: string;
    videoBtnLink : string;
}